import { render, staticRenderFns } from "./activityOrderDetail.vue?vue&type=template&id=217ae185&scoped=true"
import script from "./activityOrderDetail.vue?vue&type=script&lang=js"
export * from "./activityOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./activityOrderDetail.vue?vue&type=style&index=0&id=217ae185&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217ae185",
  null
  
)

export default component.exports